export var SalesforceAccountType;
(function (SalesforceAccountType) {
    SalesforceAccountType[SalesforceAccountType["Customer"] = 1] = "Customer";
    SalesforceAccountType[SalesforceAccountType["Partner"] = 2] = "Partner";
    SalesforceAccountType[SalesforceAccountType["Other"] = 3] = "Other";
    SalesforceAccountType[SalesforceAccountType["Group"] = 4] = "Group";
    SalesforceAccountType[SalesforceAccountType["Competitor"] = 5] = "Competitor";
})(SalesforceAccountType || (SalesforceAccountType = {}));
export var SalesforceAccountStatus;
(function (SalesforceAccountStatus) {
    SalesforceAccountStatus[SalesforceAccountStatus["Prospect"] = 1] = "Prospect";
    SalesforceAccountStatus[SalesforceAccountStatus["SignedUp"] = 2] = "SignedUp";
    SalesforceAccountStatus[SalesforceAccountStatus["Active"] = 3] = "Active";
    SalesforceAccountStatus[SalesforceAccountStatus["Churned"] = 4] = "Churned";
})(SalesforceAccountStatus || (SalesforceAccountStatus = {}));
export var SalesforceType;
(function (SalesforceType) {
    SalesforceType["Account"] = "Account";
    SalesforceType["Contact"] = "Contact";
})(SalesforceType || (SalesforceType = {}));
